/*
 * Authors: mariushirjanu
 * Created: 19/10/2021
 */
import * as _ from 'underscore';
import { ICodeDescription, IObject } from '../../../type_definitions/datatypes';
import { IFileUploadFailResponse, IFileUpload, IFileUploadResponse, ResponseStatus } from './file-upload.service';
import { GaMessageService } from '../message/ga-message.service';
import { TranslationService } from '../translation/translation.service';

// this class handles the default functionality of file upload and can be used be inherited inside of components
export class FileUploadDefault {
  public busy:boolean;
  public uploading:boolean;
  public uploadFormData:ICodeDescription;
  public progress:number;
  private filename:string;

  private abortFn:Function;
  private uploadingStatusMessage:Noty;
  private uploadFailedMessage:Noty;
  protected statusMessages:IObject;

  constructor(
    protected gaMessageService:GaMessageService,
    protected translationService:TranslationService
  ) {/***/
  }

  public onFileAdd(filename:string):void {
    this.filename = filename;
    this.busy = true;
    this.uploading = true;
  }

  protected onAfterSubmit(submitHandler:XMLHttpRequest):void {
    this.abortFn = submitHandler.abort;
    this.busy = false;
  }

  public onUploadStarted():void {
    this.gaMessageService.closeMessage(this.uploadFailedMessage); // close any previous failed message
    const message:string = this.statusMessages?.uploadingMessage? this.translationService.instant(this.statusMessages?.uploadingMessage) : this.translationService.instant('GA.FORM.UPLOAD.UPLOADING', { label: this.filename });
    this.uploadingStatusMessage = this.gaMessageService.showStatusMessage(message);
  }

  protected onUploadProgress(progress:number):void {
    this.progress = progress;
  }

  protected onUploadDone(result:IFileUpload, callback?:Function):void {
    this.uploading = false;
    this.gaMessageService.closeMessage(this.uploadingStatusMessage);
    this.gaMessageService.showFeedbackMessage('GA.FORM.UPLOAD.UPLOAD_OK');
    if (_.isFunction(callback)) {
      callback(result?.response?.data);
    }
  }

  protected onUploadFailed(response:IFileUploadFailResponse | IFileUploadResponse, callback?:Function):void {
    this.gaMessageService.closeMessage(this.uploadingStatusMessage);
    this.uploading = false;

    let errorMessage:string = this.translationService.instant(this.statusMessages?.failedMessage || 'GA.FORM.UPLOAD.UPLOAD_FAIL');
    if (response) {
      if (response?.status === ResponseStatus.FAIL) {
        // exception returned by server
        errorMessage += `: ${response.message}`;
      } else if (response.status) {
        // internal server error detected by JQueryFileUpload
        errorMessage += `: ${this.filename} (${response.status}${(<IFileUploadFailResponse>response).error? ' ' + (<IFileUploadFailResponse>response).error : ''})`;
      }
    }

    this.uploadFailedMessage = this.gaMessageService.showErrorMessage(errorMessage);
    if (_.isFunction(callback)) {
      callback(errorMessage);
    }
  }
}
